import {TweenLite,Power3} from "gsap/umd/TweenMax";
import {Controller,Scene} from "../vendor/ScrollMagic";
import { getElementHorizontalMetrics } from '../utils/get-element-metrics'

class AnimationControl {

	constructor() {
		this.scrollMagicController = new Controller();
		this.scenes = [];
		this.defaultProps = {
			distance:50
		};
		var animatedElements = document.querySelectorAll('.will-animate');
		if (window.noAnimations == true) {
			[...animatedElements].map((elem)=>{
				elem.style.opacity = '1';
			});
		} else {
			var wh = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;
			[...animatedElements].map((elem)=>{
				var scene = new Scene({triggerElement: elem, offset: -window.outerHeight/4});
					scene.addTo(this.scrollMagicController);
					scene.on("enter", this.elementInView.bind(this));

				this.scenes.push(scene);
			});
		}
	}

	elementInView(event) {
		let element = event.target.triggerElement();
		let dataset = element.dataset;

		if ( !element.classList.contains('is-animated') ) {
			element.classList.add('is-animated');

			let toProps = {
				delay:dataset.animdelay ? dataset.animdelay : 0
				,ease:dataset.animease ? window[dataset.animease].easeOut : Power3.easeOut
			};
			let fromProps = {
				delay:dataset.animdelay ? dataset.animdelay : 0
				,ease:dataset.animease ? window[dataset.animease].easeOut : Power3.easeOut
			};
			let setProps = {};

			switch (dataset.animtype){
				case 'up':
					fromProps.opacity = 1;
					toProps.opacity = 1;
					fromProps.y = this.defaultProps.distance;
					break;
				case 'fade':
					toProps.opacity = 1;
					break;
				case 'fadedown':
					toProps.opacity = 1;
					fromProps.y = -this.defaultProps.distance;
					break;
				case 'fadeup':
					toProps.opacity = 1;
					fromProps.y = this.defaultProps.distance;
					break;
				case 'faderight':
					toProps.opacity = 1;
					fromProps.x = this.defaultProps.distance;
					break;
				case 'fadeleft':
					toProps.opacity = 1;
					fromProps.x = -this.defaultProps.distance;
					break;
				case 'fadescale':
					toProps.opacity = 1;
					fromProps.scale = 0.6;
					break;
				case 'scaledown':
					fromProps.opacity = 1;
					toProps.opacity = 1;
					fromProps.scale = 1.1;
					break;
				case 'slidedown':
					setProps.opacity = 1;
					fromProps.height = 0;
					fromProps.padding = 0;
					break;
			}
			let duration = dataset.animduration ? dataset.animduration : 2;

			TweenLite.set(element, setProps);
			TweenLite.to(element,duration,toProps);
			TweenLite.from(element,duration,fromProps);
		}
	}
}

export default AnimationControl;
